<template>
  <div>
    <!-- Educational Information Card -->
    <v-card variant="outlined" class="pa-2">
      <v-card-title class="text-subtitle-1 mb-1 pa-2 d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <v-icon class="me-1" size="small">mdi-school</v-icon>
          Educational Information
        </div>

      </v-card-title>

      <!-- Educational Information Form -->
      <div class="pa-2">
        <v-form ref="educationFormRef" v-model="formValid">
          <!-- Scrollable Table Container -->
          <div class="table-container" style="max-height: 450px; overflow-y: auto; overflow-x: auto; border: 1px solid #e0e0e0; border-radius: 8px; background: #ffffff; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <!-- Table Header -->
            <v-row class="ma-0 sticky-header" style="background: #f8f9fa; position: sticky; top: 0; z-index: 10; border-bottom: 1px solid #e0e0e0; min-height: 40px;">
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 100px;">
                <div class="text-caption font-weight-bold" style="color: #1976d2;">Level</div>
              </v-col>
              <v-col cols="12" md="2" class="pa-2 d-flex align-center" style="min-width: 150px;">
                <div class="text-caption font-weight-bold" style="color: #1976d2;">Examination</div>
              </v-col>
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 80px;">
                <div class="text-caption font-weight-bold" style="color: #1976d2;">Year</div>
              </v-col>
              <v-col cols="12" md="2" class="pa-2 d-flex align-center" style="min-width: 200px;">
                <div class="text-caption font-weight-bold" style="color: #1976d2;">Subject</div>
              </v-col>
              <v-col cols="12" md="2" class="pa-2 d-flex align-center" style="min-width: 200px;">
                <div class="text-caption font-weight-bold" style="color: #1976d2;">Board</div>
              </v-col>
              <v-col cols="12" md="2" class="pa-2 d-flex align-center" style="min-width: 180px;">
                <div class="text-caption font-weight-bold" style="color: #1976d2;">Institution</div>
              </v-col>
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 100px;">
                <div class="text-caption font-weight-bold" style="color: #1976d2;">Result</div>
              </v-col>
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 100px;">
                <div class="text-caption font-weight-bold" style="color: #1976d2;">Marks</div>
              </v-col>
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 120px;">
                <div class="text-caption font-weight-bold" style="color: #1976d2;">Actions</div>
              </v-col>
            </v-row>

            <!-- Below SSC Row -->
            <v-row class="ma-0 form-row" style="min-height: 48px; background: #ffffff; border-bottom: 1px solid #f0f0f0;">
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 100px;">
                <div class="text-caption font-weight-medium" style="color: #424242;">Below SSC</div>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 150px;">
                <v-text-field
                  v-model="educationalInfo.below_ssc.examination"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Exam Name"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 80px;">
                <v-select
                  v-model="educationalInfo.below_ssc.passing_year"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="yearOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Year"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-text-field
                  v-model="educationalInfo.below_ssc.subject_group"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Subject"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-select
                  v-model="educationalInfo.below_ssc.board"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="boardOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Board"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 180px;">
                <v-text-field
                  v-model="educationalInfo.below_ssc.institution"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Institute"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-select
                  v-model="educationalInfo.below_ssc.result"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="resultOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Result"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-text-field
                  v-model="educationalInfo.below_ssc.marks_gpa"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Marks"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 120px;">
                <!-- Empty Actions column for alignment -->
              </v-col>
            </v-row>

            <!-- SSC/Equivalent Row -->
            <v-row class="ma-0 form-row" style="min-height: 48px; background: #fafafa; border-bottom: 1px solid #f0f0f0;">
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 100px;">
                <div class="text-caption font-weight-medium" style="color: #424242;">SSC/Equivalent</div>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 150px;">
                <v-select
                  v-model="educationalInfo.ssc_equivalent.examination"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="examinationOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Select"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 80px;">
                <v-select
                  v-model="educationalInfo.ssc_equivalent.passing_year"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="yearOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Year"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-text-field
                  v-model="educationalInfo.ssc_equivalent.subject_group"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Subject"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-select
                  v-model="educationalInfo.ssc_equivalent.board"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="boardOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Board"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 180px;">
                <v-text-field
                  v-model="educationalInfo.ssc_equivalent.institution"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Institute"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-select
                  v-model="educationalInfo.ssc_equivalent.result"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="resultOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Result"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-text-field
                  v-model="educationalInfo.ssc_equivalent.marks_gpa"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Marks"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 120px;">
                <!-- Empty Actions column for alignment -->
              </v-col>
            </v-row>

            <!-- HSC/Equivalent Row -->
            <v-row class="ma-0 form-row" style="min-height: 48px; background: #fafafa; border-bottom: 1px solid #f0f0f0;">
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 100px;">
                <div class="text-caption font-weight-medium" style="color: #424242;">HSC/Equivalent</div>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 150px;">
                <v-select
                  v-model="educationalInfo.hsc_equivalent.examination"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="examinationOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Select"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 80px;">
                <v-select
                  v-model="educationalInfo.hsc_equivalent.passing_year"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="yearOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Year"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-text-field
                  v-model="educationalInfo.hsc_equivalent.subject_group"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Subject"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-select
                  v-model="educationalInfo.hsc_equivalent.board"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="boardOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Board"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 180px;">
                <v-text-field
                  v-model="educationalInfo.hsc_equivalent.institution"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Institute"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-select
                  v-model="educationalInfo.hsc_equivalent.result"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="resultOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Result"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-text-field
                  v-model="educationalInfo.hsc_equivalent.marks_gpa"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Marks"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 120px;">
                <!-- Empty Actions column for alignment -->
              </v-col>
            </v-row>

            <!-- Graduate Row -->
            <v-row class="ma-0 form-row" style="min-height: 48px; background: #ffffff; border-bottom: 1px solid #f0f0f0;">
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 100px;">
                <div class="text-caption font-weight-medium" style="color: #424242;">Graduate</div>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 150px;">
                <v-select
                  v-model="educationalInfo.graduation.examination"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="examinationOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Select"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 80px;">
                <v-select
                  v-model="educationalInfo.graduation.passing_year"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="yearOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Year"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-text-field
                  v-model="educationalInfo.graduation.subject_group"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Subject"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-select
                  v-model="educationalInfo.graduation.board"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="boardOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Board"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 180px;">
                <v-text-field
                  v-model="educationalInfo.graduation.institution"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Institute"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-select
                  v-model="educationalInfo.graduation.result"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="resultOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Result"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-text-field
                  v-model="educationalInfo.graduation.marks_gpa"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Marks"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 120px;">
                <!-- Empty Actions column for alignment -->
              </v-col>
            </v-row>

            <!-- Masters Degree Section -->
            <div class="mt-3 mb-2 ">
              <div class="text-caption font-weight-medium ml-2" style="color:blue; margin-bottom: 8px;">
                You Can Add Multiple Degree For Masters
              </div>
              <v-divider class="mb-2"></v-divider>
            </div>

            <!-- Masters Degree Row -->
            <v-row class="ma-0 form-row" style="min-height: 48px; background: #f8f9fa; border-bottom: 1px solid #f0f0f0;">
              <v-col cols="12" md="1" class="pa-2 d-flex align-start" style="min-width: 100px;">
                <div class="text-caption font-weight-medium" style="color: #424242; margin-top: 2px;">Masters Degree</div>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 150px;">
                <v-select
                  v-model="educationalInfo.masters.examination"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="examinationOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Select"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 80px;">
                <v-select
                  v-model="educationalInfo.masters.passing_year"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="yearOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Year"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-text-field
                  v-model="educationalInfo.masters.subject_group"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Subject"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                <v-text-field
                  v-model="educationalInfo.masters.board"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Board"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pa-2" style="min-width: 180px;">
                <v-text-field
                  v-model="educationalInfo.masters.institution"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Institute"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-select
                  v-model="educationalInfo.masters.result"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :items="resultOptions"
                  item-title="text"
                  item-value="value"
                  placeholder="Result"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                <v-text-field
                  v-model="educationalInfo.masters.marks_gpa"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  placeholder="Marks"
                  style="font-size: 0.8rem;"
                  class="compact-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-2 d-flex align-start" style="min-width: 120px;">
                <v-btn
                  color="orange"
                  size="small"
                  variant="elevated"
                  @click="addAdditionalDegree"
                  style="min-width: 80px; height: 28px; margin-top: 2px;"
                  class="compact-btn"
                >
                <v-icon size="x-small" class="me-1">mdi-plus</v-icon>
                  Add More
                </v-btn>
              </v-col>
            </v-row>

            <!-- Additional Masters Degrees -->
            <div v-for="(degree, index) in educationalInfo.additional_degrees" :key="index" class="mb-1">
              <v-row class="ma-0 form-row" style="min-height: 48px; background: #f0f8ff; border-bottom: 1px solid #e0e0f0;">
                <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 100px;">
                  <div class="text-caption font-weight-medium" style="color: #424242;">Masters {{ index + 2 }}</div>
                </v-col>
                <v-col cols="12" md="2" class="pa-2" style="min-width: 150px;">
                  <v-select
                    v-model="degree.examination"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    :items="examinationOptions"
                    item-title="text"
                    item-value="value"
                    placeholder="Select"
                    style="font-size: 0.8rem;"
                    class="compact-field"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="1" class="pa-2" style="min-width: 80px;">
                  <v-select
                    v-model="degree.passing_year"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    :items="yearOptions"
                    item-title="text"
                    item-value="value"
                    placeholder="Year"
                    style="font-size: 0.8rem;"
                    class="compact-field"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                  <v-text-field
                    v-model="degree.subject_group"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    placeholder="Subject"
                    style="font-size: 0.8rem;"
                    class="compact-field"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="pa-2" style="min-width: 200px;">
                  <v-select
                    v-model="degree.board"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    :items="boardOptions"
                    item-title="text"
                    item-value="value"
                    placeholder="Board"
                    style="font-size: 0.8rem;"
                    class="compact-field"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="2" class="pa-2" style="min-width: 180px;">
                  <v-text-field
                    v-model="degree.institution"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    placeholder="Institute"
                    style="font-size: 0.8rem;"
                    class="compact-field"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                  <v-select
                    v-model="degree.result"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    :items="resultOptions"
                    item-title="text"
                    item-value="value"
                    placeholder="Result"
                    style="font-size: 0.8rem;"
                    class="compact-field"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="1" class="pa-2" style="min-width: 100px;">
                  <v-text-field
                    v-model="degree.marks_gpa"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    placeholder="Marks"
                    style="font-size: 0.8rem;"
                    class="compact-field"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="pa-2 d-flex align-center" style="min-width: 120px;">
                  <!-- Empty Actions column for alignment -->
                </v-col>
              </v-row>
            </div>

            <div class="mt-3 mb-2 ">
              <div class="text-subtitle-2 mb-2 ml-2">Document Uploads</div>
              <v-row class="ma-0 ml-2">
                <v-col cols="6" md="2" class="pa-1">
                  <div class="text-caption font-weight-medium mb-1" style="color: #1976d2;">Certificate File</div>
                  <v-file-input
                    v-model="certificateFile"
                    label="Choose File"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    accept=".pdf,.jpg,.jpeg,.png"
                    show-size
                  ></v-file-input>
                </v-col>
                <v-col cols="6" md="2" class="pa-1">
                  <div class="text-caption font-weight-medium mb-1" style="color: #1976d2;">Transcript File</div>
                  <v-file-input
                    v-model="transcriptFile"
                    label="Choose File"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    accept=".pdf,.jpg,.jpeg,.png"
                    show-size
                  ></v-file-input>
                </v-col>
              </v-row>
            </div>
          </div>

        </v-form>
        
        <!-- Certificate and Transcript Files Section -->
       
        
      </div>

    </v-card>

    <!-- Add/Edit Education Dialog -->
    <v-dialog v-model="showEducationDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>{{ isEditing ? 'Edit' : 'Add' }} Educational Information</span>
          <v-btn icon="mdi-close" variant="text" @click="closeEducationDialog"></v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="educationFormRef" v-model="formValid" class="pa-1">
            <v-row class="ma-0">
              <v-col cols="12" md="6" class="pa-1">
                <v-text-field
                  v-model="educationForm.institution_name"
                  label="Institution Name"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :rules="[v => !!v || 'Institution name is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-1">
                <v-text-field
                  v-model="educationForm.degree"
                  label="Degree"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :rules="[v => !!v || 'Degree is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-1">
                <v-text-field
                  v-model="educationForm.field_of_study"
                  label="Field of Study"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-1">
                <v-text-field
                  v-model="educationForm.grade"
                  label="Grade"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-1">
                <v-text-field
                  v-model="educationForm.start_date"
                  label="Start Date"
                  type="date"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :rules="[v => !!v || 'Start date is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-1">
                <v-text-field
                  v-model="educationForm.end_date"
                  label="End Date"
                  type="date"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-1">
                <v-text-field
                  v-model="educationForm.gpa"
                  label="GPA"
                  type="number"
                  step="0.01"
                  min="0"
                  max="4"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pa-1">
                <v-textarea
                  v-model="educationForm.description"
                  label="Description"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  rows="3"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="6" class="pa-1">
                <v-file-input
                  v-model="certificateFile"
                  label="Certificate File"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  accept=".pdf,.jpg,.jpeg,.png"
                  show-size
                ></v-file-input>
              </v-col>
              <v-col cols="12" md="6" class="pa-1">
                <v-file-input
                  v-model="transcriptFile"
                  label="Transcript File"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  accept=".pdf,.jpg,.jpeg,.png"
                  show-size
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-2">
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeEducationDialog" :disabled="saving">Cancel</v-btn>
          <v-btn
            color="primary"
            variant="outlined"
            @click="saveEducation"
            :disabled="!formValid || saving"
            :loading="saving"
          >
            {{ isEditing ? 'Update' : 'Save' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { toast } from 'vue3-toastify'

// Props
const props = defineProps({
  employeeId: {
    type: [String, Number],
    required: true
  }
})

// Store
const store = useStore()

// Reactive data
const saving = ref(false)
const showEducationDialog = ref(false)
const isEditing = ref(false)
const formValid = ref(false)
const certificateFile = ref(null)
const transcriptFile = ref(null)
const educationalInfoList = ref([])

// Form data
const educationForm = ref({
  id: null,
  institution_name: '',
  degree: '',
  field_of_study: '',
  start_date: '',
  end_date: '',
  gpa: '',
  grade: '',
  description: '',
  employee_id: props.employeeId,
  branch_id: null,
  company_id: null,
  status: 1
})

// Educational information data structure for table interface
const educationalInfo = ref({
  below_ssc: {
    id: null,
    examination: '',
    passing_year: '',
    subject_group: '',
    board: '',
    institution: '',
    result: '',
    marks_gpa: ''
  },
  ssc_equivalent: {
    id: null,
    examination: '',
    passing_year: '',
    subject_group: '',
    board: '',
    institution: '',
    result: '',
    marks_gpa: ''
  },
  hsc_equivalent: {
    id: null,
    examination: '',
    passing_year: '',
    subject_group: '',
    board: '',
    institution: '',
    result: '',
    marks_gpa: ''
  },
  graduation: {
    id: null,
    examination: '',
    passing_year: '',
    subject_group: '',
    board: '',
    institution: '',
    result: '',
    marks_gpa: ''
  },
  masters: {
    id: null,
    examination: '',
    passing_year: '',
    subject_group: '',
    custom_subject: '',
    board: '',
    custom_institution: '',
    institution: '',
    result: '',
    marks_gpa: ''
  },
  additional_degrees: []
})

// Options for dropdowns
const yearOptions = computed(() => {
  const currentYear = new Date().getFullYear()
  const years = []
  for (let i = currentYear; i >= 1950; i--) {
    years.push({ text: i.toString(), value: i })
  }
  return years
})

const examinationOptions = [
  { text: 'S.S.C', value: 'ssc' },
  { text: 'H.S.C', value: 'hsc' },
  { text: 'Bachelor', value: 'bachelor' },
  { text: 'Master', value: 'master' },
  { text: 'Ph.D', value: 'phd' },
  { text: 'Diploma', value: 'diploma' },
  { text: 'Certificate', value: 'certificate' }
]

const boardOptions = [
  { text: 'Dhaka Board', value: 'dhaka' },
  { text: 'Chittagong Board', value: 'chittagong' },
  { text: 'Rajshahi Board', value: 'rajshahi' },
  { text: 'Sylhet Board', value: 'sylhet' },
  { text: 'Barisal Board', value: 'barisal' },
  { text: 'Comilla Board', value: 'comilla' },
  { text: 'Jessore Board', value: 'jessore' },
  { text: 'Dinajpur Board', value: 'dinajpur' },
  { text: 'Mymensingh Board', value: 'mymensingh' }
]

const institutionOptions = [
  { text: 'University of Dhaka', value: 'du' },
  { text: 'Bangladesh University of Engineering and Technology', value: 'buet' },
  { text: 'University of Chittagong', value: 'cu' },
  { text: 'Jahangirnagar University', value: 'ju' },
  { text: 'Rajshahi University', value: 'ru' },
  { text: 'Khulna University', value: 'ku' },
  { text: 'Bangladesh Agricultural University', value: 'bau' },
  { text: 'Islamic University', value: 'iu' },
  { text: 'Shahjalal University of Science and Technology', value: 'sust' }
]

const subjectOptions = [
  { text: 'Computer Science', value: 'cs' },
  { text: 'Mathematics', value: 'math' },
  { text: 'Physics', value: 'physics' },
  { text: 'Chemistry', value: 'chemistry' },
  { text: 'Biology', value: 'biology' },
  { text: 'English', value: 'english' },
  { text: 'Bangla', value: 'bangla' },
  { text: 'Economics', value: 'economics' },
  { text: 'Business Administration', value: 'business' },
  { text: 'Engineering', value: 'engineering' }
]

const resultOptions = [
  { text: 'First Class', value: 'first_class' },
  { text: 'Second Class', value: 'second_class' },
  { text: 'Third Class', value: 'third_class' },
  { text: 'Pass', value: 'pass' },
  { text: 'A+', value: 'a_plus' },
  { text: 'A', value: 'a' },
  { text: 'A-', value: 'a_minus' },
  { text: 'B+', value: 'b_plus' },
  { text: 'B', value: 'b' },
  { text: 'B-', value: 'b_minus' },
  { text: 'C+', value: 'c_plus' },
  { text: 'C', value: 'c' },
  { text: 'D', value: 'd' },
  { text: 'F', value: 'f' }
]

// Form ref
const educationFormRef = ref(null)

// Methods

const addNewEducation = () => {
  resetForm()
  isEditing.value = false
  showEducationDialog.value = true
}

const editEducation = (education) => {
  educationForm.value = { ...education }
  isEditing.value = true
  showEducationDialog.value = true
}

const closeEducationDialog = () => {
  showEducationDialog.value = false
  resetForm()
}

const resetForm = () => {
  educationForm.value = {
    id: null,
    institution_name: '',
    degree: '',
    field_of_study: '',
    start_date: '',
    end_date: '',
    gpa: '',
    grade: '',
    description: '',
    employee_id: props.employeeId,
    branch_id: null,
    company_id: null,
    status: 1
  }
  certificateFile.value = null
  transcriptFile.value = null
}

const saveEducation = async () => {
  try {
    saving.value = true
    
    // Validate form
    const { valid } = await educationFormRef.value.validate()
    if (!valid) return

    // Prepare form data
    const formData = new FormData()
    
    // Add form fields
    Object.keys(educationForm.value).forEach(key => {
      if (educationForm.value[key] !== null && educationForm.value[key] !== '') {
        formData.append(key, educationForm.value[key])
      }
    })

    // Add files
    if (certificateFile.value && certificateFile.value.length > 0) {
      formData.append('certificate_file', certificateFile.value[0])
    }
    if (transcriptFile.value && transcriptFile.value.length > 0) {
      formData.append('transcript_file', transcriptFile.value[0])
    }

    // Save educational info
    await store.dispatch('educationalInfo/saveEducationalInfo', formData)
    
    // Reload the list
    await loadEducationalInfo()
    
    // Close dialog
    closeEducationDialog()
    
  } catch (error) {
    // Handle error silently
  } finally {
    saving.value = false
  }
}

const deleteEducation = async (id) => {
  if (confirm('Are you sure you want to delete this educational information?')) {
    try {
      await store.dispatch('educationalInfo/deleteEducationalInfo', id)
      await loadEducationalInfo()
    } catch (error) {
      // Handle error silently
    }
  }
}

// Load educational information for the employee
const dataLoaded = ref(false)
const loadEducationalInfo = async () => {
  if (dataLoaded.value) return
  try {
    const response = await store.dispatch('educationalInfo/getEducationalInfoByEmployee', props.employeeId)
    if (response.success && response.data) {
      // Clear existing data first
      educationalInfo.value = {
        below_ssc: {
          id: null,
          examination: '',
          passing_year: '',
          subject_group: '',
          board: '',
          institution: '',
          result: '',
          marks_gpa: ''
        },
        ssc_equivalent: {
          id: null,
          examination: '',
          passing_year: '',
          subject_group: '',
          board: '',
          institution: '',
          result: '',
          marks_gpa: ''
        },
        hsc_equivalent: {
          id: null,
          examination: '',
          passing_year: '',
          subject_group: '',
          board: '',
          institution: '',
          result: '',
          marks_gpa: ''
        },
        graduation: {
          id: null,
          examination: '',
          passing_year: '',
          subject_group: '',
          board: '',
          institution: '',
          result: '',
          marks_gpa: ''
        },
        masters: {
          id: null,
          examination: '',
          passing_year: '',
          subject_group: '',
          custom_subject: '',
          board: '',
          custom_institution: '',
          institution: '',
          result: '',
          marks_gpa: ''
        },
        additional_degrees: []
      }

      // Map the data to form fields
      response.data.forEach((record, index) => {
        if (record.level === 'additional_masters') {
          educationalInfo.value.additional_degrees.push({
            id: record.id,
            examination: record.examination || '',
            passing_year: record.passing_year || '',
            subject_group: record.subject_group || '',
            board: record.board || '',
            institution: record.institution || '',
            result: record.result || '',
            marks_gpa: record.marks_gpa || ''
          })
        } else if (educationalInfo.value[record.level]) {
          educationalInfo.value[record.level] = {
            id: record.id,
            examination: record.examination || '',
            passing_year: record.passing_year || '',
            subject_group: record.subject_group || '',
            board: record.board || '',
            institution: record.institution || '',
            result: record.result || '',
            marks_gpa: record.marks_gpa || ''
          }
        }
      })
    }
    dataLoaded.value = true
  } catch (error) {
    // Handle error silently
  }
}

// Save all educational information for the employee
const saveAllEducationalInfo = async () => {
  console.log('=== saveAllEducationalInfo called from parent ===')
  try {
    saving.value = true
    
    // Prepare the educational data
    const educationalData = {
      below_ssc: educationalInfo.value.below_ssc,
      ssc_equivalent: educationalInfo.value.ssc_equivalent,
      hsc_equivalent: educationalInfo.value.hsc_equivalent,
      graduation: educationalInfo.value.graduation,
      masters: educationalInfo.value.masters,
      additional_degrees: educationalInfo.value.additional_degrees || []
    }
    
    // Prepare files for upload
    const files = {}
    
    if (certificateFile.value) {
      // Handle both single file and array of files
      const file = Array.isArray(certificateFile.value) ? certificateFile.value[0] : certificateFile.value
      if (file) {
        files.certificateFile = file
      }
    }
    
    if (transcriptFile.value) {
      // Handle both single file and array of files
      const file = Array.isArray(transcriptFile.value) ? transcriptFile.value[0] : transcriptFile.value
      if (file) {
        files.transcriptFile = file
      }
    }


    const response = await store.dispatch('educationalInfo/saveEmployeeEducationalInfo', {
      employeeId: props.employeeId,
      educationalData: educationalData,
      files: files
    })
    
    if (response.success) {
      // Reload the data
      await loadEducationalInfo()
      toast.success('Educational information saved successfully')
    } else {
      // Throw error to be handled by parent component
      throw new Error('Failed to save educational information: ' + response.message)
    }
  } catch (error) {
    // Re-throw error to be handled by parent component
    throw error
  } finally {
    saving.value = false
  }
}

// Add more masters degree
const addAdditionalDegree = () => {
  educationalInfo.value.additional_degrees.push({
    id: null,
    examination: '',
    passing_year: '',
    subject_group: '',
    board: '',
    institution: '',
    result: '',
    marks_gpa: ''
  })
}

// Remove additional degree
const removeAdditionalDegree = (index) => {
  if (confirm('Are you sure you want to remove this degree?')) {
    educationalInfo.value.additional_degrees.splice(index, 1)
  }
}

// Save individual education level
const saveEducationLevel = async (level) => {
  try {
    saving.value = true
    
    const formData = new FormData()
    formData.append('employee_id', props.employeeId)
    formData.append('level', level)
    
    // Add the level data
    Object.keys(educationalInfo.value[level]).forEach(key => {
      if (educationalInfo.value[level][key]) {
        formData.append(key, educationalInfo.value[level][key])
      }
    })
    
    if (certificateFile.value && certificateFile.value.length > 0) {
      formData.append('certificate_file', certificateFile.value[0])
    }
    if (transcriptFile.value && transcriptFile.value.length > 0) {
      formData.append('transcript_file', transcriptFile.value[0])
    }

    await store.dispatch('educationalInfo/saveEducationalInfo', formData)
    await loadEducationalInfo()
  } catch (error) {
    // Handle error silently
  } finally {
    saving.value = false
  }
}

// Load data on component mount
onMounted(() => {
  console.log('=== EDUCATIONAL INFO COMPONENT MOUNTED ===')
  console.log('Employee ID:', props.employeeId)
  if (props.employeeId) {
    loadEducationalInfo()
  }
})

// Watch for employee ID changes
// watch(() => props.employeeId, (newId) => {
//   if (newId) {
//     educationForm.value.employee_id = newId
//     loadEducationalInfo()
//   }
// }, { immediate: true })

// Expose methods to parent component
defineExpose({
  saveAllEducationalInfo,
  saving: computed(() => saving.value)
})
</script>

<style scoped>
/* Custom styles for comfortable form design */
.custom-field {
  transition: all 0.2s ease-in-out;
}

.custom-field:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.custom-field:focus-within {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
}

.save-btn {
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.save-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.table-container {
  /* scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1; */
  width: 100%;
  /* min-width: 1520px; */
  display: block;
  position: relative;
}

/* Ensure columns maintain minimum widths */
.v-col[style*="min-width"] {
  flex: 0 0 auto !important;
}

/* Table row styling */
.v-row {
  min-width: 1520px;
}

/* Column width enforcement */
.v-col {
  box-sizing: border-box;
}

/* Ensure table maintains proper structure */
.table-container .v-row {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  min-width: 1520px;
}

/* Ensure individual columns maintain their widths */
.table-container .v-col {
  flex-shrink: 0;
  flex-grow: 0;
}

/* Force horizontal scrolling when content overflows */
.table-container {
  /* overflow-x: auto !important; */
  overflow-y: auto !important;
  width: 100% !important;
  max-width: none !important;
}

/* Ensure parent containers don't constrain width */
.pa-2 {
  overflow-x: visible !important;
}

/* Make sure the form doesn't constrain the table */
.v-form {
  overflow-x: visible !important;
}

/* Override any Vuetify constraints on the table container */
.table-container {
  /* overflow-x: scroll !important; */
  overflow-y: auto !important;
  white-space: nowrap;
}

/* Ensure the table content doesn't wrap */
.table-container .v-row {
  white-space: nowrap;
}

/* Compact field styling */
.compact-field {
  transition: all 0.2s ease-in-out;
}

.compact-field:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.compact-field:focus-within {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
}

/* Compact button styling */
.compact-btn {
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.compact-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Form row styling */
.form-row:nth-of-type(odd) {
  background: #ffffff !important;
}

.form-row:nth-of-type(even) {
  background: #fafafa !important;
}

/* Compact form field styling */
.compact-field .v-field__input {
  min-height: 28px !important;
  padding: 2px 6px !important;
  font-size: 0.8rem !important;
}

.compact-field .v-field__outline {
  --v-field-border-width: 1px;
}

.compact-field .v-field__outline__start,
.compact-field .v-field__outline__end {
  border-radius: 4px;
}

/* Compact button styling */
.compact-btn .v-btn__content {
  font-size: 0.75rem;
  line-height: 1.2;
}

/* Compact select dropdowns */
.compact-field .v-field__append-inner {
  padding: 0 4px;
}

.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Row hover effects */
.v-row:hover {
  background-color: rgba(25, 118, 210, 0.02) !important;
  transition: background-color 0.2s ease-in-out;
}

/* Sticky header enhancement */
.sticky-header {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: #f8f9fa !important;
  border-bottom: 1px solid #e0e0e0 !important;
}

/* Form field focus enhancement */
.v-field--focused {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2) !important;
}

/* Button group styling */
.v-btn-group .v-btn {
  margin: 0 2px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-container {
    max-height: 400px;
  }
  
  .custom-field {
    font-size: 0.75rem !important;
  }
  
  .save-btn {
    min-width: 50px !important;
    height: 24px !important;
    font-size: 0.7rem !important;
  }
  
  .text-caption {
    font-size: 0.7rem !important;
  }
}

/* Compact form styling */
.custom-field .v-field__input {
  min-height: 32px !important;
  padding: 4px 8px !important;
}

.custom-field .v-field__outline {
  --v-field-border-width: 1px;
}

.custom-field .v-field__outline__start,
.custom-field .v-field__outline__end {
  border-radius: 4px;
}

/* Make buttons more compact */
.save-btn .v-btn__content {
  font-size: 0.75rem;
  line-height: 1.2;
}

/* Compact select dropdowns */
.custom-field .v-field__append-inner {
  padding: 0 4px;
}

/* Compact text fields */
.custom-field .v-field__input {
  font-size: 0.8rem;
}

/* Prevent text overlapping in form fields */
.custom-field {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-field .v-field__input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Ensure proper spacing for form elements */
.v-text-field, .v-select {
  width: 100%;
}

/* Fix for dropdown text overlapping */
.v-select .v-field__input {
  padding-right: 24px;
}

/* Ensure proper button spacing */
.save-btn {
  white-space: nowrap;
}
</style>
